import { render } from "./_mainLayout.vue?vue&type=template&id=fdb69698"
import script from "./_mainLayout.vue?vue&type=script&lang=js"
export * from "./_mainLayout.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Program Files\\Jenkins\\.jenkins\\workspace\\Статистика приема\\Univeris.AdmissionStatistics.Frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__